import React, { useEffect, useState } from "react";
import { Avatar, Card, Flex, Typography, Button, Rate } from "antd";
import { useNavigate } from "react-router-dom";
import axios from "axios";

const { Text } = Typography;

const DoctorCard = ({ doctor }) => {
  const navigate = useNavigate();
  const [rating, setRating] = useState(null);

  useEffect(() => {
    const fetchRating = async () => {
      try {
        const res = await axios.get(`/api/reviews/doctor/${doctor._id}`);
        if (res.data.success) {
          setRating(res.data.rating);
        }
      } catch (err) {
        console.error("Error fetching rating:", err);
      }
    };

    fetchRating();
  }, [doctor._id]);

  return (
    <Card hoverable style={{ borderRadius: 12 }}>
      <Flex gap="middle" align="center">
        {/* Avatar */}
        <Avatar
          size={64}
          style={{
            backgroundColor: doctor?.gender === "female" ? "#eb2f96" : "#87d068",
            verticalAlign: "middle",
          }}
        >
          {doctor?.firstName?.[0]?.toUpperCase()}
        </Avatar>

        {/* Doctor Info */}
        <Flex vertical style={{ flex: 1 }}>
          <Text strong>
            Dr. {doctor.firstName} {doctor.lastName}
          </Text>
          <Text type="secondary">Specialty: {doctor.service}</Text>
          <Text type="secondary" style={{ fontSize: 13 }}>
            City: {doctor.location} &middot; Service Fee: ₦{doctor.feePerConsultation}
          </Text>
       <Text type="secondary" style={{ fontSize: 12 }}>
  {rating ? (
    <span>
      <span>Rating:</span>
      <Rate
        disabled
        allowHalf
        defaultValue={parseFloat(rating)}
        style={{
          fontSize: 5,
        }}
      />
      <span>({rating})</span>
    </span>
  ) : (
    "No rating yet for this doctor"
  )}
</Text>


        </Flex>

        {/* Action */}
        <Button
          type="primary"
          onClick={() => navigate(`/book-appointment/${doctor._id}`)}
        >
          Book
        </Button>
      </Flex>
    </Card>
  );
};

export default DoctorCard;
